@for (menuItem of menuItems; track menuItem) {
  <div (mouseenter)="mouseOverEnterExpand(menuItem)" (mouseleave)="mouseOverLeaveCollapse(menuItem)"
    [ngClass]="{'menu-item-active': isRouteActive(menuItem)}"
    class="menu-item" data-cy="side-bar-menu-collapsed-item">
    <a [routerLink]="menuItem.url" [ngClass]="['menu-icon', menuItem.icon]" (click)="changeContext()"
      data-cy="side-bar-menu-collapsed-item-icon">
    </a>
    @if (menuItem.isExpanded) {
      <div class="menu-submenu">
        <span class="menu-section-header" data-cy="menu-section-header">{{menuItem.label}}</span>
        <div class="menu-separator" data-cy="menu-separator"></div>
        <app-side-bar-menu-item [menuItems]="menuItem.children"
        (click)="mouseClickCollapse(menuItem)"></app-side-bar-menu-item>
      </div>
    }
  </div>
}
